import { useQuery, gql } from '@apollo/client'
import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import slugify from 'slugify'
import { getCustomNoOptionText } from 'components/CountrySearchLegacy'
import { Select } from 'components/Select'

export const STATE_QUERY = gql`
  query states($input: AutocompleteInput!) {
    states(input: $input) {
      title
    }
  }
`

export const StateSearchLegacy = ({
  value,
  onChange,
  isError,
  hint,
  countryIsoCode,
  isRequiredField = false,
  ...rest
}) => {
  const [inputValue, setInputValue] = useState(value.title)
  const [selectedValue, setSelectedValue] = useState(value)

  const stateQuery = useQuery(STATE_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        countryIsoCode,
        search: slugify(inputValue || ''),
      },
    },
  })

  useEffect(() => {
    setInputValue(value.title)
    setSelectedValue(value)
  }, [value])

  const states = stateQuery?.data?.states || []
  const customNoOptionsText = getCustomNoOptionText({
    inputValue,
    isLoading: stateQuery.loading,
    options: states,
    label: 'state',
  })
  return (
    <Select
      isDisabled={!countryIsoCode}
      hasHint
      label={isRequiredField ? 'State*' : 'State'}
      autocomplete={false}
      isError={isError}
      hint={hint}
      isSearchable
      value={selectedValue}
      getOptionLabel={(item) => item.title}
      getOptionValue={(item) => item.title}
      customNoOptionsText={customNoOptionsText}
      options={states}
      onInputChange={setInputValue}
      onChange={({ title }) => {
        const newValue = {
          title,
          value: title,
        }
        onChange(newValue)
        setSelectedValue(newValue)
      }}
      {...rest}
    />
  )
}

StateSearchLegacy.propTypes = {
  value: PropTypes.shape({
    title: PropTypes.string,
    value: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  isError: PropTypes.bool,
  hint: PropTypes.string,
  countryIsoCode: PropTypes.string,
  isRequiredField: PropTypes.bool,
}
